const buildAttorneySidebar = function () {
  jQuery('.m-attorney-content').each(function (index) {
    let id = jQuery(this).attr('id'),
        title = jQuery(this).find('h4').text();
    jQuery('.o-attorney-single__sidebar-nav').append('<li id="menu-item-' + id + '"><a href="#' + id + '">' + title + '</a></li>');
  });
  stickyAttorneySidebar();
  highlightAttorneySidebar();
}

const stickyAttorneySidebar = function () {
  jQuery(document).scroll(function () {
    let scT = jQuery(document).scrollTop(),
        headH = jQuery('.header').height(),
        banH = jQuery('.m-banner').height(),
        tH = (headH + banH) + 204,
        docW = jQuery(document).width(),
        set = jQuery('.m-attorney-content'),
        length = set.length;

    if(docW > 960) {
      set.each(function(index) {
        if (index == (length - 1)) {
          let lastID = jQuery(this).attr('id'),
              freeze = jQuery("#" + lastID).offset().top - 140;

          if (scT > freeze) {
            jQuery('.o-attorney-single__sidebar').addClass("o-attorney-single__sidebar--anchor");
            jQuery('.o-attorney-single__sidebar').attr('style', 'top:' + freeze + 'px !important');
          } else {
            jQuery('.o-attorney-single__sidebar').removeClass("o-attorney-single__sidebar--anchor");
            jQuery('.o-attorney-single__sidebar').removeAttr('style');
          }
        }
      });

      if (scT > tH) {
        jQuery('.o-attorney-single__sidebar').addClass("o-attorney-single__sidebar--sticky");
      } else {
        jQuery('.o-attorney-single__sidebar').removeClass("o-attorney-single__sidebar--sticky");
      }
    }
    else {
      jQuery('.o-attorney-single__sidebar').removeClass("o-attorney-single__sidebar--anchor");
      jQuery('.o-attorney-single__sidebar').removeAttr('style');
    }
  });
}

const highlightAttorneySidebar = function () {
  jQuery(document).scroll(function () {
    let currrentActiveId = '',
        activeId = '',
        docW = jQuery(document).width();

    if(docW > 960) {
      if (jQuery('.m-attorney-content.current').length > 0) {
        currrentActiveId = jQuery('.m-attorney-content.current').attr('id');
      }
      else {
        currrentActiveId = jQuery('.m-attorney-content:first').attr('id');
        jQuery('#menu-item-' + currrentActiveId).addClass('current');
      }
      activeId = currrentActiveId;

      let topOfViewport = jQuery(window).scrollTop(),
          headingHeight = 88;

      jQuery('.m-attorney-content').each(function () {
        let id = jQuery(this).attr('id');
        let anchorTop = jQuery('#' + id).offset().top - headingHeight;

        if (anchorTop < topOfViewport) {
          activeId = id;
        }
      });

      jQuery('.o-attorney-single__sidebar-nav li').removeClass('current');
      jQuery('#menu-item-' + activeId).addClass('current');
    }
    else {
      jQuery('.o-attorney-single__sidebar-nav li').removeClass('current');
    }

  });
}

export {
  buildAttorneySidebar,
  stickyAttorneySidebar,
  highlightAttorneySidebar
}
